/**
 * Logger utility for injection scripts
 */

import { LOG_PREFIX, isDevelopment } from "@/constants";
import type { Logger } from "@/types";

export const createLogger = (
  scriptName: string,
  debug = isDevelopment,
): Logger => {
  const prefix = `${LOG_PREFIX}:${scriptName}`;

  return {
    log: (message: string, ...args: unknown[]) => {
      if (debug) {
        console.log(`${prefix} ${message}`, ...args);
      }
    },
    warn: (message: string, ...args: unknown[]) => {
      console.warn(`${prefix} ${message}`, ...args);
    },
    error: (message: string, ...args: unknown[]) => {
      console.error(`${prefix} ${message}`, ...args);
    },
  };
};
